import React from "react";

import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home/Home";
import Products from "../pages/Products/Products";
import Layout from "../layout/Layout";
import About from "../pages/About/About";
import Business from "../pages/Business/Business";
import Support from "../pages/Support/Support";
import NotFound from "../pages/NotFound/NotFound";
import Infinite353 from "../pages/Products/Infinite353/Infinite353";
import Infinite60 from "../pages/Products/Infinite60/Infinite60";
import Infinite50 from "../pages/Products/Infinite50/Infinite50";
import Infinite110 from "../pages/Products/Infinite110/Infinite110";
import Infinite313 from "../pages/Products/Infinite313/Infinite313";
import RegisterInterest from "../pages/RegisterInterest/RegisterInterest";

const RouteContainer = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />}></Route>
        <Route path="/products" element={<Products />}></Route>
        <Route path="/infinite-353" element={<Infinite353 />}></Route>
        <Route path="/infinite-50" element={<Infinite50 />}></Route>
        <Route path="/infinite-60" element={<Infinite60 />}></Route>
        <Route path="/infinite-313" element={<Infinite313 />}></Route>
        <Route path="/infinite-110" element={<Infinite110 />}></Route>
        <Route path="/infinite-for-businesses" element={<Business />}></Route>
        <Route path="/support" element={<Support />}></Route>
        <Route path="/about" element={<About />}></Route>
        <Route path="/contact" element={<div>Contact</div>}></Route>
        <Route path="/register-interest" element={<RegisterInterest />}></Route>
      </Route>

      <Route path="*" element={<NotFound />}></Route>
    </Routes>
  );
};

export default RouteContainer;
